"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePaletteOverrides = void 0;
var _react = require("react");
var _context = require("./context");
const usePaletteOverrides = () => {
  const paletteOverrides = (0, _react.useContext)(_context.PaletteOverridesContext);
  return paletteOverrides;
};
exports.usePaletteOverrides = usePaletteOverrides;